import { Link } from "react-router-dom";

const Nav = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-success">
      <ul className="navbar-nav me-auto mb-2 mb-lg-1">
        <li className="nav-item ">
          <Link className="nav-link fs-4 extra me-3" to="" style={{ color: "#f8f9fa"}}>
            Ashwin's Team Member Allocation App
          </Link>
        </li>
        <li className="nav-item alignCss">
          <Link className="nav-link fs-4" to="/">
            {" "}
            <b>Home</b>{" "}
          </Link>
        </li>
        <li className="nav-item fs-4 alignCss">
          <Link className="nav-link" to="/GroupedTeamMembers">
            {" "}
            <b>Teams</b>{" "}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
